
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  FiLogIn, FiLogOut, FiClipboard, FiUser,
} from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';

import './styles.css';
import { setSidebarVisible } from '../../../support/store/SidebarReducer';
import { logOut } from '../../../support/store/AuthReducer';

function Sidebar() {
  const visible = useSelector((state) => state.SidebarReducer.sidebarVisible);
  const retrievedToken = useSelector((state) => state.AuthReducer.token);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const closeSidebar = () => {
    dispatch(setSidebarVisible({ visible: false }));
  };

  const onOpenOrders = () => {
    history.push('/orders');
    dispatch(setSidebarVisible({ visible: false }));
  };

  const onOpenUserData = () => {
    history.push('/userdata');
    dispatch(setSidebarVisible({ visible: false }));
  };

  const onLogin = () => {
    history.push({
      pathname: '/login',
      state: { previousPath: location.pathname },
    });
    dispatch(setSidebarVisible({ visible: false }));
  };

  const onLogOut = () => {
    if (window.confirm('Deseja sair da sua conta?')) {
      dispatch(logOut());
      dispatch(setSidebarVisible({ visible: false }));
    }
  };


  if (!visible) return <></>;

  return (
    <div className="blur-background fade-in">
      <div className="blur-close" onClick={closeSidebar} />

      <div className="sidebar-wrapper slide-right">
        <div className="sidebar-container">
          {
            retrievedToken
              ? (
                <>
                  <button type="button" className="sidebar-btn" onClick={onOpenOrders}>
                    <FiClipboard size={23} color="#000" />
                    <p>Meus pedidos</p>
                  </button>

                  <button type="button" className="sidebar-btn" onClick={onOpenUserData}>
                    <FiUser size={23} color="#000" />
                    <p>Meus dados</p>
                  </button>

                  <button type="button" className="sidebar-btn red-btn" onClick={onLogOut}>
                    <FiLogOut size={23} color="#c50000" />
                    <p>Sair</p>
                  </button>
                </>
              )
              : (
                <button type="button" className="sidebar-btn green-btn" onClick={onLogin}>
                  <FiLogIn size={23} color="#168500" />
                  <p>Entrar</p>
                </button>
              )
          }

        </div>
      </div>
    </div>
  );
}

export default Sidebar;
